import * as React from "react"

import { cn } from "@/lib/utils"

export interface SwitchProps
  extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, "onChange"> {
  checked?: boolean
  onCheckedChange?: (checked: boolean) => void
}

const Switch = React.forwardRef<HTMLButtonElement, SwitchProps>(
  ({ className, checked = false, onCheckedChange, disabled, ...props }, ref) => {
    return (
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        disabled={disabled}
        ref={ref}
        onClick={() => onCheckedChange?.(!checked)}
          className={cn(
          "relative inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--interactive-primary)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--bg-surface)] disabled:cursor-not-allowed disabled:opacity-50",
          checked
            ? "border-[var(--interactive-primary)] bg-[var(--interactive-primary)]"
            : "border-[var(--border-default)] bg-[color-mix(in_srgb,var(--text-muted)_28%,var(--bg-subtle))]",
          className
        )}
        {...props}
      >
        <span
          className={cn(
            "pointer-events-none block h-5 w-5 rounded-full shadow-sm ring-0 transition-transform",
            checked
              ? "translate-x-5 bg-[var(--btn-primary-label)]"
              : "translate-x-0 bg-[var(--bg-elevated)]"
          )}
        />
      </button>
    )
  }
)
Switch.displayName = "Switch"

export { Switch }
